export const API_PATH = '/v1/track-activity';
